import { render } from "./LimitsAndCreditsTable.vue?vue&type=template&id=73963a67&scoped=true"
import script from "./LimitsAndCreditsTable.vue?vue&type=script&lang=js"
export * from "./LimitsAndCreditsTable.vue?vue&type=script&lang=js"

import "./LimitsAndCreditsTable.vue?vue&type=style&index=0&id=73963a67&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73963a67"]])

export default __exports__